module.exports = __webpack_public_path__ + "roboto-v15-latin-300.16ddb1541046ada9b90c.woff2";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/roboto-v15-latin-300.woff2
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.woff2
// module chunks = 2